module.exports = __webpack_public_path__ + "img/logo_mnu_white.ee338173.png";